import React from "react";

import "./style.scss";
import SEO from "Components/SEO";
import Navbar from "Components/Navbar";
import { homeConfig } from "./config";
import FeatureEventHeader from "Components/FeatureEventPage/FeatureEventHeader/FeatureEventHeader";
import WorldOfMetaverse from "Components/WorldOfMetaverse";
import FeatureHostEarnings from "Components/FeatureEventPage/FeatureHostEarnings/FeatureHostEarnings";
import MeetVREvents from "Components/FeatureEventPage/MeetVREvents/MeetVREvents";
import EventEarner from "Components/FeatureEventPage/EventEarner/EventEarner";
import HowItWorksSection from "Components/FeatureEventPage/HowItWorksSection/HowItWorksSection";
import GetStartedSection from "Components/GetStartedSection/GetStartedSection";
import VirtualExplorer from "Components/FeatureEventPage/VirtualExplorer/VirtualExplorer";
const FeatureEvent = () => {
    const { underConstruction, underConstructionMessage, SEO_DATA } =
        homeConfig;

    if (underConstruction) {
        return <h1>{underConstructionMessage}</h1>;
    }

    return (
        <div id={"feature-page-wrapper"} style={{ overflowX: "hidden" }}>
            <SEO
                title={SEO_DATA.title}
                description={SEO_DATA.description}
                keywords={SEO_DATA.keywords}
            />

            <div style={{ position: "relative" }}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        zIndex: 10,
                    }}
                >
                    <Navbar />
                </div>
                <FeatureEventHeader />
                <WorldOfMetaverse />
                <FeatureHostEarnings />
                <MeetVREvents />
                <EventEarner />
                <HowItWorksSection />
                <VirtualExplorer />
                <GetStartedSection />
            </div>
        </div>
    );
};

export default FeatureEvent;
